var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ServiceHelpers } from 'src/services/ServicesHelpers';
// Add abort controller to cancel request on demand and parse payload received if parser is provided
export var serviceCreator = function (method, url, isAuth, requestParams) {
    var _a = requestParams || {}, parser = _a.parser, restRequestParams = __rest(_a, ["parser"]);
    var service = new ServiceHelpers(method, url);
    if (isAuth) {
        return {
            abort: function () { return (service.abortController ? service.abortController.abort() : null); },
            callAPI: function () {
                return service.callAuth(restRequestParams).then(function (res) { return (parser && res.payload ? parser(res) : res); });
            },
        };
    }
    return {
        abort: function () { return (service.abortController ? service.abortController.abort() : null); },
        callAPI: function () { return service.call(restRequestParams).then(function (res) { return (parser && res.payload ? parser(res) : res); }); },
    };
};
